import { IRegion, RegionAbbr } from '@novakid/ts-types';

export function getUserRegion(
  regions: IRegion[],
  userRegionCode?: RegionAbbr | null,
): IRegion | undefined {
  return regions.find(({ code }) => code === userRegionCode)
  || regions.find(({ code }) => code === 'GLOBAL');
}